<template>
  <div class="modal is-active">
    <div class="modal-background"></div>

    <div class="modal-content outwin">
      <div id="drawArea">
        <canvas class="drawAreaCanvas" ref="drawCanvas" width="720" height="480"></canvas>
      </div>
      <div class="ctr">
        <div
          v-bind:class="{ itemSelected: (btnMode=='draw' && selectPen=='fine'), itemNormal: ( (btnMode=='draw' && selectPen=='bold') || btnMode!='draw' ) }"
          v-on:click="selectAction('penFine')"
        >
          <span class="fa fa-pencil"></span>
          <span class="menutext">細いペン</span>
        </div>
        <div
          v-bind:class="{ itemNormal: ( (btnMode=='draw' && selectPen=='fine') || btnMode!='draw' ), itemSelected: (btnMode=='draw' && selectPen=='bold')  }"
          v-on:click="selectAction('penBold')"
        >
          <span class="fa fa-paint-brush"></span>
          <span class="menutext">太いペン</span>
        </div>

        <div
          class="itemColor itemColorWhite"
          v-bind:class="{ itemColorDisabled: btnMode!='draw' }"
          v-on:click="selectAction('colorWhite')"
        >
          <span v-if="selectColor=='white'" class="fa fa-check"></span>
        </div>
        <div
          class="itemColor itemColorRed"
          v-bind:class="{ itemColorDisabled: btnMode!='draw' }"
          v-on:click="selectAction('colorRed')"
        >
          <span v-if="selectColor=='red'" class="fa fa-check"></span>
        </div>
        <div
          class="itemColor itemColorBlue"
          v-bind:class="{ itemColorDisabled: btnMode!='draw' }"
          v-on:click="selectAction('colorBlue')"
        >
          <span v-if="selectColor=='blue'" class="fa fa-check"></span>
        </div>
        <div
          class="itemColor itemColorGreen"
          v-bind:class="{ itemColorDisabled: btnMode!='draw' }"
          v-on:click="selectAction('colorGreen')"
        >
          <span v-if="selectColor=='green'" class="fa fa-check"></span>
        </div>

        <div
          v-bind:class="{ itemNormal: (btnMode!='delete'),itemSelected: (btnMode=='delete') }"
          v-on:click="selectAction('delete')"
        >
          <span class="fa fa-eraser"></span>
          <span class="menutext">削除</span>
        </div>

        <div
          v-bind:class="{ itemNormal: !this.isViewSupportLine,itemSelected: this.isViewSupportLine }"
          v-on:click="selectAction('supportLine')"
        >
          <span class="fa fa-ellipsis-h"></span>
          <span class="menutext">ガイド線</span>
        </div>

        <div class="itemNormal itemLeftSpace" v-on:click="selectAction('close')">
          <span class="fa fa-check"></span>
          <span class="menutext">完了</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@media (max-width: 640px) {
  .menutext {
    display: none;
  }
}

.outwin {
  width: 100%;
}
#drawArea {
  padding: 20px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ctr {
  display: flex;
  justify-content: center;
}

.itemNormal {
  background-color: gray;
  border: 1px solid gray;
  border-radius: 5px;
  padding: 5px;
  height: 35px;
  margin: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.itemSelected {
  background-color: rgb(61, 61, 61);
  border: 1px solid gray;
  border-radius: 5px;
  padding: 5px;
  height: 35px;
  margin: 5px;
  cursor: pointer;
  white-space: nowrap;
}
.drawAreaCanvas {
  display: block;
}
.itemColor {
  border-radius: 5px;
  color: black;
  margin: 5px;
  padding: 5px;
  width: 35px;
  height: 35px;
  text-align: center;
  cursor: pointer;
}
.itemColorDisabled {
  opacity: 0.3;
}

.itemColorWhite {
  background-color: #F44063;
}
.itemColorRed {
  background-color: #4CF1F7;
}
.itemColorBlue {
  background-color: #93FF00;
}
.itemColorGreen {
  background-color: #F14EFF;
}

.itemLeftSpace {
  margin-left: 20px;
}
</style>
<script>
export default {
  name: "VideoSetting",
  data() {
    return {
      drawCanvas: null,
      btnMode: "draw",
      data: null,
      selectColor: "aaa",
      selectPen: null,
      isViewSupportLine: false
    };
  },
  props: ["soraImageBase64"],
  mounted() {
    let canvas = this.$refs.drawCanvas;
    let w = window.innerWidth * 0.9;
    let h = (w * 9) / 16;

    if (window.innerHeight < h) {
      h = window.innerHeight * 0.6;
      w = (h * 16) / 9;
    }

    this.drawCanvas = new DrawCanvas(canvas, w, h);
    this.drawCanvas.addEventListener("update", e => {
      this.data = e.data;
      this.$emit("update-data", e.data);
    });
    this.drawCanvas.setBackgroundImage(this.soraImageBase64);
    this.drawCanvas.drawColors = { r: 244, g: 64, b: 99, a: 255 };
    this.selectColor = "white";
    this.drawCanvas.setDrawStroke(8);
    this.selectPen = "bold";
  },
  methods: {
    selectAction(key) {
      console.log(key);
      this.isViewSupportLine = this.drawCanvas.isSupportLine();
      switch (key) {
        case "close":
          this.$emit("fix-data", this.data);
          break;
        case "penFine":
          this.drawCanvas.setMode("draw");
          this.drawCanvas.setDrawStroke(3);
          this.selectPen = "fine";
          break;
        case "penBold":
          this.drawCanvas.setMode("draw");
          this.drawCanvas.setDrawStroke(8);
          this.selectPen = "bold";
          break;
        case "colorWhite":
          this.drawCanvas.setMode("draw");
          this.drawCanvas.drawColors = { r: 244, g: 64, b: 99, a: 255 };
          this.selectColor = "white";
          break;
        case "colorRed":
          this.drawCanvas.setMode("draw");
          this.drawCanvas.drawColors = { r: 76, g: 241, b: 247, a: 255 };
          this.selectColor = "red";
          break;
        case "colorBlue":
          this.drawCanvas.setMode("draw");
          this.drawCanvas.drawColors = { r: 147, g: 255, b: 0, a: 255 };
          this.selectColor = "blue";
          break;
        case "colorGreen":
          this.drawCanvas.setMode("draw");
          this.drawCanvas.drawColors = { r: 241, g: 78, b: 255, a: 255 };
          this.selectColor = "green";
          break;
        case "delete":
          this.drawCanvas.setMode("delete");
          break;
        case "supportLine":
          this.drawCanvas.setMode("support");
          if (this.isViewSupportLine) {
            this.isViewSupportLine = false;
            this.drawCanvas.setMode("draw");
            this.drawCanvas.setDrawStroke(this.drawCanvas.getDrawStroke());
            this.selectPen =
              this.drawCanvas.getDrawStroke() == 3 ? "fine" : "bold";
          } else {
            this.isViewSupportLine = true;
          }

          break;
      }

      if (
        this.drawCanvas.getMode() == "draw" ||
        this.drawCanvas.getMode() == "delete" ||
        this.drawCanvas.getMode() == "support"
      ) {
        this.btnMode = this.drawCanvas.getMode();
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/VideoDraw.vue